import { render, staticRenderFns } from "./game-setting.vue?vue&type=template&id=ef75b724&scoped=true&"
import script from "./game-setting.vue?vue&type=script&lang=js&"
export * from "./game-setting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef75b724",
  null
  
)

export default component.exports